class ArrayService<T> {
  private readonly arrayIndex: keyof T;

  constructor(arrayIndex: keyof T) {
    this.arrayIndex = arrayIndex;
  }

  reIndexArray = (array: T[]): T[] =>
    array.map((item, index) => ({
      ...item,
      [this.arrayIndex]: index + 1,
    }));

  addItem(array: T[], item: T): T[] {
    const newItem = { ...item, [this.arrayIndex]: array.length + 1 };
    return [...array, newItem];
  }

  removeItem(array: T[], item: T): T[] {
    const index = array.findIndex(
      (i) => i[this.arrayIndex] === item[this.arrayIndex]
    );

    const updatedArray = array.filter((_, i) => i !== index);
    return this.reIndexArray(updatedArray);
  }

  updateItem(array: T[], oldItemIndex: number, newItem: T): T[] {
    const oldItem = array[oldItemIndex - 1];
    const updatedArray = array.map((i) => (i === oldItem ? newItem : i));

    return this.reIndexArray(updatedArray);
  }
}

export default ArrayService;
